var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shuiyin"},[_c('i'),_c('div',{staticClass:"companyName"},[_vm._v(_vm._s(_vm.companyName))]),_c('div',{staticClass:"nameAndTime"},[_vm._v(_vm._s(_vm.username)+": "+_vm._s(_vm.currentYMD()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }